export function encodeGenericAOE(profession: string, aoe: string) {
  return `${profession}|||${aoe}`;
}

export function encodeGenericSpec(profession: string, spec: string) {
  return `${profession}|||${spec}`;
}

export function encodeAOEExp(aoe: string, spec: string) {
  return `${aoe}|||${spec}`;
}

export function encodeProfAoeSpec(prof: string, aoe = "", spec = "") {
  return `${prof}|||${aoe}|||${spec}`;
}

export function decodeProfAoeSpec(v: string) {
  return v.split("|||") as [string, string, string];
}
